import { color, MiscUtils } from '@my/util'
const { Dimensions } = XPReactNative
import { useForm } from 'react-hook-form'
import { YStack, KeyBoardAvoidView, XPReactNative, ActionButton, SimpleText, XStack, Text } from '@my/ui'
import { shadowGenerator } from '../../../utils/commonStyles'
import { ChatHeader, ChatInput, ChatMessages, SuggestedQuestions } from '../../../components/index'
import { TypingIndicator, useSavvyChat, NoticeSection } from '../../savvy/Savvy'
import { SquarePen } from '@tamagui/lucide-icons-2'

const { width } = Dimensions.get('window')

// ModalDialog Component
export const ModalDialog: React.FC<ModalDialogProps> = ({
  modalVisible,
  setModalVisible,
  /* messages,
  onChatInput,
  suggestedQuestions, */
}) => {
  const [messages, onChatInput, suggestedQuestions, systemIsTyping, clearMessages, notice, actionFns ] = useSavvyChat();
  const { control, reset, getValues } = useForm({
    defaultValues: {
      chatInput: '',
    },
  })

  const handleSubmit = (text: string) => {
    if (text.trim()) {
      onChatInput(text)
      reset()
    }
  }

  if (!modalVisible) return null

  const containerStyle = {
    bottom: width < 500 ? 80 : 70,
    right: width < 500 ? 20 : 70,
    position: 'fixed' as const,
    maxWidth: 700,
    width: 'auto',
    height: '75%',
    backgroundColor: color.white,
    borderRadius: 10,
    ...shadowGenerator(0.3),
    minWidth: width > 600 ? 700 : width - 30,
    gap: 10,
  }

  const newMessageButton = messages.length > 2 ? <ActionButton
    icon={<SquarePen />}
    onPress={async () => {
      const shouldClear = await MiscUtils.dialog.confirm("Are you sure?", "(Proceeding will delete Savvy's responses and start a new chat.)");
      if (shouldClear) {
        clearMessages()
      }
    }}
    borderRadius={15}
    //backgroundColor={color.tzaGreen}
  >
    <SimpleText fontSize={15} /* color={'#fff'} */>
      New Chat
    </SimpleText>
  </ActionButton> : undefined
  return (
    <KeyBoardAvoidView props={containerStyle}>
      <ChatHeader text="Savvy" additionalStuff={newMessageButton} />
      <YStack flex={1} width="100%" alignItems="center" paddingHorizontal={20}>
        {notice.show ? <XStack marginHorizontal={-20} marginBottom={10}><NoticeSection acknowledge={notice.acknowledge} /></XStack> : null}
        <ChatMessages messages={messages} actionFns={actionFns}/>
        <YStack
          width="100%"
          justifyContent="flex-end"
          
          marginBottom={10}
          gap={10}
        >
          {messages.length < 2 && (
            <SuggestedQuestions
              suggestedQuestions={suggestedQuestions}
              handleSubmit={handleSubmit}
            />
          )}
          {systemIsTyping ? <TypingIndicator /> : null}
          <ChatInput control={control} onSubmit={handleSubmit} getValues={getValues} />
        </YStack>
      </YStack>
    </KeyBoardAvoidView>
  )
}
